<template>
    <v-container class="pa-0 ma-0 bg">
    <v-row class="pa-0 ma-0">

      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="text-center">
        <h1 class="font-weight-bold my-5">
          Pilih Organisasi Anda
        </h1>

        <!-- -------button tenant----- -->
        <div  v-if="is_admin" >
          <v-btn v-if="isCan('organisasi.store')" color="primary" depressed large @click="add" class="mx-3">
            <v-icon left> mdi-plus-thick </v-icon>
            Tambah Organisasi
          </v-btn>
          <v-btn color="purple lighten-2" dark large depressed @click="toKelola" class="mx-3">
            <v-icon left> mdi-cog </v-icon>
            Kelola Tenant
          </v-btn>
        </div>

        <v-row>
          <v-col cols="12" md="8" offset-md="2">
            <p class="mt-10 text-center grey--text text--darken-2">
              Jika Anda menemukan lebih dari 1 Instansi/Organisasi yang muncul
              pada akses Anda ini. Artinya akun Anda terdaftar sebagai pengguna di
              <b>lebih dari 1 Instansi/Organisasi</b>. Silakan pilih atau cari
              instansi/organisasi yang ingin Anda tuju
            </p>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="px-5">
        <v-card flat
          class="px-5 transparent"
          align="center"
        >
            <v-text-field
              solo large
               class="mb-10"
              v-model="textSearch"
              placeholder="Cari Organisasi"
              hint style="width:60%;"
              clearable
              append-icon="mdi-magnify"
              @click:append="pencarian(textSearch)"
              @keyup.enter="pencarian(textSearch)"
              @click:clear="hapusPencarian()"
            ></v-text-field>


          <v-card-text no-gutters>

            <v-row row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-for="item in items"
                :key="item.organisasi_id"
              >
                <BlockCard
                  :is_organisasi="true"
                  :title="item.nama"
                  :logo="item.file_foto"
                  :height="145"
                  color="white" class="balck--text el-custom"
                  @pilih="pilihOrganisasi(item)"
                  to
                />
              </v-col>
            </v-row>

            <v-row wrap class="pt-5" v-if="page">
              <v-col
                v-if="page.total"
                :cols="$vuetify.breakpoint.smAndUp ? 1 : 3"
                class="text-left"
                align="center"
                justify="center"
              >
                <v-select
                  :items="totalPagination"
                  v-model="jump_page"
                  @change="jump"
                  label="Hal."
                ></v-select>
              </v-col>
              <v-col
                cols="9"
                v-if="$vuetify.breakpoint.smAndUp"
                class="text-center"
              >
                <v-pagination circle
                  v-if="page.total"
                  v-model="current_page"
                  :length="page.last_page"
                  :total-visible="6"
                  @input="change"
                ></v-pagination>
              </v-col>
              <v-col
                :cols="$vuetify.breakpoint.smAndUp ? 2 : 9"
                v-if="page.from"
                class="text-right"
              >
                <p class="caption font-weight-bold">
                  {{ page.from }} - {{ page.to }} dari {{ page.total }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Form ref="dlg" :tenant="tenant" />
  </v-container>

</template>

<script>
import BlockCard from "@/components/BlockCard";
import Form from "../components/FormAdmin";
export default {
  components: {
    BlockCard,
    Form
  },
  data() {
    return {
      dialog: true,
      organisasi: {},
      items: [],
      current_page: 1,
      page: null,
      cp: 1,
      textSearch: "",
      total: 0,
      jump_page: 0,
      totalPagination: [],
      tenant: {},
    };
  },
  activated() {
    this.dialog = true;
    this.current_page = 1;
    this.load(this.current_page);
    this.loadDetail()
    this.jump_page = this.page ? this.page.current_page : 1;
  },
  computed: {
    is_admin() {
      return this.current_user && this.current_user.is_admin == 1
        ? true
        : false;
    }
  },
  methods: {
    load(current_page) {
      return this.$store
        .dispatch("organisasi/get", {
          page: current_page,
          keyword: this.textSearch,
          count: 8
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
          this.total = res.data.total;
        })
        .catch(e => e);
    },
    loadDetail() {
      if(this.current_user && this.current_user.is_admin !== 1) return

      this.$store
        .dispatch(
          'tenant/detail',
           this.current_user.kode_tenant
        )
        .then((res) => {
          this.tenant = res.data
        })
        .catch((e) => e)
    },
    jump() {
      if (Number.isInteger(this.jump_page)) {
        this.$emit("change:page", this.jump_page);
      }
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load(1);
      });
    },
    pencarian(s) {
      this.textSearch = s;
      this.cp = 1;
      this.current_page = 1;
      this.load(1);
    },
    hapusPencarian() {
      this.textSearch = null;
      this.load(1);
    },
    toKelola() {
      this.$store.commit('organisasi/setOrganisasiId', null)
      this.$store.commit('organisasi/setOrganisasi', null)
      return this.$router.push({
        name: "dashboardTenant"
      });
    },
    change() {
      this.load(this.current_page);
    },
    pilihOrganisasi(item) {
      return this.$store
        .dispatch("organisasi/switchOrganisasi", item.kode_organisasi)
        .then(() => {
          if (this.$vuetify.breakpoint.smAndUp) {
            this.$store.commit("main/setLDrawer", true);
          }
          return this.$router.push({
            name: "home",
            params: { organisasi_id: item.kode_organisasi }
          });
        })
        .catch(() => {
          this.$store.commit("main/noOrganisasi", true, { root: true });
        });
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    }
  }
};
</script>

<style>
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot{
  -webkit-box-shadow: 0px 5px 15px 5px #94afff56 !important;
  box-shadow: 0px 5px 15px 5px #94afff56 !important;
}
.el-custom{
  -webkit-box-shadow: 3px 5px 10px 1px #5a7de71f !important;
}
.bg{
      background-image: url("https://cdn.siap.id/s3/masook/asset%20img/SIM/bg-switch.png");
      background-size: cover;
        }
</style>
